/**
 * Search, filter and sort defaults for the entity list (CT-5281).
 *
 * There are no option sets here, unlike the Widget Library's equivalent. The
 * dimensions a type can be narrowed and ordered by come down WITH the rows,
 * because a Dealership and a Vehicle share no fields — a hardcoded list is the
 * one thing this domain exists to avoid. Only the defaults are code.
 */

/** The one field the normalized row contract guarantees. */
export const DEFAULT_SORT_FIELD = 'title';

/** A list of names reads alphabetically, so `asc` is the default here. */
export const DEFAULT_SORT_DIRECTION = 'asc';

/**
 * The Records list orders by recency instead: the record someone touched last is
 * the one they are most likely to want. The tab lists inside a profile keep the
 * alphabetical default above — they offer no recency sort.
 */
export const RECORDS_SORT_FIELD = 'last_interaction';
export const RECORDS_SORT_DIRECTION = 'desc';

/** Searched server-side. Both are part of the normalized contract. */
export const SEARCH_FIELDS = ['title', 'description'];

/** How long the box holds a keystroke before it reaches the request. */
export const SEARCH_DEBOUNCE_MS = 400;

/** Direction is a fixed pair — unlike the fields, it does not vary per type. */
export const SORT_DIRECTION_OPTIONS = [
  { value: 'asc', labelKey: 'list.sort.ascending' },
  { value: 'desc', labelKey: 'list.sort.descending' },
];
